














function throttle(func, wait) {
    //节流
    let timer = null;
    return function() {
        if (timer) {
            return false;
        } else {
            timer = setTimeout(() => {
                func.apply(this, arguments);
                timer = null;
            }, wait);
        }
    };
}
export {throttle};


// WEBPACK FOOTER //
// ./src/axios/util.js